// extracted by mini-css-extract-plugin
export default {"pending":"status_pending__b1rl+","approved":"status_approved__7wdcP","rejected":"status_rejected__Xm4xa","pending_approval":"status_pending_approval__Hxnky"};